import { createIconSetFromFontello } from "@expo/vector-icons";
import fontelloConfig from "./icon-font.json";

const Icon = createIconSetFromFontello(
	fontelloConfig,
	"memorangicons",
	"memorangicons.ttf",
);
export default Icon;
